import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import Splide from '@splidejs/splide';
export var imageGalleryBehavior = function imageGalleryBehavior() {
  Alpine.data('imageGalleryBehavior', function () {
    return {
      carouselIsShowing: false,
      carousel: undefined,
      init: function init() {
        // When modal appears, refresh carousel to ensure its on the correct slide.
        this.watch('carouselIsShowing');
        this.initSlider();
      },
      initSlider: function initSlider() {
        if (this.carousel === undefined) {
          this.carousel = new Splide(this.$el.querySelector('.m-carousel'), {
            rewind: true,
            pagination: true,
            arrows: false,
            type: 'loop',
            focus: 'center',
            perPage: 1,
            mediaQuery: 'min',
            gap: '2.25rem',
            breakpoints: {
              768: {
                perPage: 1,
                gap: '5rem',
                padding: '5rem'
              },
              1024: {
                gap: '10rem'
              }
            }
          });
          var galleryThumbnails = this.$el.querySelector('.image-gallery-thumbnails');
          var thumbnails = new Splide(galleryThumbnails, {
            pagination: false,
            arrows: false,
            isNavigation: true
          });
          this.carousel.sync(thumbnails);
          this.carousel.mount();
          thumbnails.mount();
        }
      },
      watch: function watch(property) {
        var _this = this;
        this.$watch(property, function (newValue) {
          console.log(property);
          if (newValue === true) {
            setTimeout(function () {
              _this.refreshCarousel();
            }, 50);
          }
        });
      },
      refreshCarousel: function refreshCarousel() {
        this.carousel.refresh();
      }
    };
  });
};